import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon, CalendarIcon } from 'lucide-react';
interface DaySelectorProps {
  selectedDate: Date;
  onDateChange: (date: Date) => void;
}
export function DaySelector({
  selectedDate,
  onDateChange
}: DaySelectorProps) {
  const days = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
  // Get current week's days
  const getWeekDays = (date: Date) => {
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is Sunday
    const monday = new Date(date);
    monday.setDate(diff);
    const weekDays = [];
    for (let i = 0; i < 7; i++) {
      const newDate = new Date(monday);
      newDate.setDate(monday.getDate() + i);
      weekDays.push(newDate);
    }
    return weekDays;
  };
  const weekDays = getWeekDays(selectedDate);
  const goToPreviousWeek = () => {
    const newDate = new Date(selectedDate);
    newDate.setDate(newDate.getDate() - 7);
    onDateChange(newDate);
  };
  const goToNextWeek = () => {
    const newDate = new Date(selectedDate);
    newDate.setDate(newDate.getDate() + 7);
    onDateChange(newDate);
  };
  const goToToday = () => {
    onDateChange(new Date());
  };
  const isToday = (date: Date) => {
    const today = new Date();
    return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
  };
  const isSelected = (date: Date) => {
    return date.getDate() === selectedDate.getDate() && date.getMonth() === selectedDate.getMonth() && date.getFullYear() === selectedDate.getFullYear();
  };
  return <div className="border-b border-gray-200 pb-4" data-id="element-273">
      <div className="flex justify-between items-center mb-4" data-id="element-274">
        <div className="flex items-center gap-2" data-id="element-275">
          <CalendarIcon size={20} className="text-gray-500" data-id="element-276" />
          <h3 className="text-lg font-semibold text-gray-800" data-id="element-277">
            {selectedDate.toLocaleDateString('de-DE', {
            month: 'long',
            year: 'numeric'
          })}
          </h3>
        </div>
        <div className="flex items-center gap-2" data-id="element-278">
          <button onClick={goToToday} className="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 rounded-md transition-colors" data-id="element-279">
            Heute
          </button>
          <button onClick={goToPreviousWeek} className="p-1 rounded-full hover:bg-gray-100" data-id="element-280">
            <ChevronLeftIcon size={20} data-id="element-281" />
          </button>
          <button onClick={goToNextWeek} className="p-1 rounded-full hover:bg-gray-100" data-id="element-282">
            <ChevronRightIcon size={20} data-id="element-283" />
          </button>
        </div>
      </div>
      <div className="grid grid-cols-7 gap-1" data-id="element-284">
        {days.map((day, index) => <div key={day} className="text-center text-xs font-medium text-gray-500" data-id="element-285">
            {day}
          </div>)}
        {weekDays.map((date, index) => <button key={index} onClick={() => onDateChange(date)} className={`
              py-2 rounded-md text-sm font-medium transition-colors
              ${isSelected(date) ? 'bg-[#8DC63F] text-white' : isToday(date) ? 'bg-blue-100 text-blue-800' : 'hover:bg-gray-100'}
            `} data-id="element-286">
            {date.getDate()}
          </button>)}
      </div>
    </div>;
}